module.exports = __webpack_public_path__ + "static/bus_urbano-68f9a0453a8997a09022304b01ada763.jpg";